import { render, staticRenderFns } from "./WarningOrderModal.vue?vue&type=template&id=cf36e1d0&scoped=true&"
import script from "./WarningOrderModal.vue?vue&type=script&lang=js&"
export * from "./WarningOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./WarningOrderModal.vue?vue&type=style&index=0&id=cf36e1d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf36e1d0",
  null
  
)

export default component.exports